/* eslint-disable no-console */
const styles = {
    info: 'background-color: cyan; color: black; padding: 2px 6px; font-weight: bold;',
    success: 'background-color: #2ecc71; color: black; padding: 2px 6px; font-weight: bold;',
    warn: 'background-color: #f1c40f; color: black; padding: 2px 6px; font-weight: bold;',
    error: 'background-color: #e74c3c; color: black; padding: 2px 6px; font-weight: bold;',
};

const logger = {
    info: (message, ...args) => {
        console.log('%c[INFO]', styles.info, message, ...args);
    },

    success: (message, ...args) => {
        console.log('%c[SUCCESS]', styles.success, message, ...args);
    },

    warn: (message, ...args) => {
        console.log('%c[WARN]', styles.warn, message, ...args);
    },

    error: (message, ...args) => {
        console.log('%c[ERROR]', styles.error, message, ...args);
    },
};

export default logger;
